// ─── My Plani Route ───
// /app/my-plani — personal, cross-workspace agenda (Phase 9 Batch F, #2).
// docs/design/components/my-plani.md "Page shell, route, layout" +
// docs/phase9/batch-f-my-plani.md §2.1. Unlike Reports/Search, this route is
// NOT a shareable portfolio URL — it always reflects the viewer's OWN
// assignments in their currently active company (TopBar switcher state,
// blueprint §6 Q2). No `workspace`/`company`/`space` search params.

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MyPlaniPage } from '../../features/my-plani/MyPlaniPage';

const myPlaniPageSearchSchema = z.object({
  /** Deep-link into the TaskDetailPanel — declared for forward compatibility
   * (blueprint §4 option B, a future stacked PR); v1 (option A) never reads
   * this on THIS route — a row click navigates AWAY to the task's list with
   * its own `?openTask=`. `.catch(undefined)` per the house "a stale
   * shareable-URL param must degrade, never crash" rule. */
  openTask: z.string().uuid().optional().catch(undefined),
  /** List ⇄ Timeline view (PR-2, docs/design/components/my-plani-timeline.md
   * "ViewToggle amendment" §) — live: the `ViewToggle` tablist drives this via
   * a shallow `replace` navigation, and `MyPlaniPage` renders `MyPlanTimeline`
   * in place of the three List sections when `view === 'timeline'`. Absent or
   * any other value falls back to `list` (the route's default tab).
   * `.catch(undefined)` keeps a stale/foreign value from crashing the route. */
  view: z.enum(['list', 'timeline']).optional().catch(undefined),
  /** Agenda ⇄ History scope (Batch F fast-follow C1b, #2,
   * docs/design/components/my-plani.md "History scope" § — ORTHOGONAL to
   * `view`, not one of its enum values). `'agenda'` (default, current+future
   * work) or `'history'` (completed-only, newest first, Load more — no date
   * cutoff, owner ruling). `MyPlaniPage` hides the ViewToggle entirely and
   * renders the day-grouped history list instead of the three List sections
   * when `scope === 'history'`. `.catch(undefined)` keeps a stale/foreign
   * value from crashing the route, same house rule as `view`/`openTask`. */
  scope: z.enum(['agenda', 'history']).optional().catch(undefined),
});

export const Route = createFileRoute('/app/my-plani')({
  validateSearch: myPlaniPageSearchSchema,
  component: MyPlaniPage,
});
